import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Button } from "./Button";
import { DropList } from "./DropList";
import { getLanguagesSet } from "../../constants";
import { setLabelByValue } from "../../helpers";
import { PageNavigatorContext } from "../../PageNavigator";
import styles from './PaginationSelect.css';
var cx = classNames.bind(styles);
var defaultItem = [20];
var placements = ['top', 'bottom'];
export var Select = function Select(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultItem : _ref$items,
      onSelect = _ref.onSelect,
      isShow = _ref.isShow,
      itemsPerPage = _ref.itemsPerPage,
      menuPlacement = _ref.menuPlacement;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var dropListRef = useRef();
  var buttonRef = useRef();

  var _useContext = useContext(PageNavigatorContext),
      locale = _useContext.locale;

  var _getLanguagesSet = getLanguagesSet(locale),
      translations = _getLanguagesSet.translations;

  useEffect(function () {
    if (isShow) {
      setIsOpen(isShow);
    }
  }, [isShow]);

  var handleSetIsOpen = function handleSetIsOpen() {
    return setIsOpen(function (prevState) {
      return !prevState;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement(Button, {
    ref: buttonRef,
    total: itemsPerPage,
    isOpen: isOpen,
    setIsOpen: handleSetIsOpen
  }), /*#__PURE__*/React.createElement(DropList, {
    ref: dropListRef,
    isOpen: isOpen,
    setIsOpen: handleSetIsOpen,
    items: setLabelByValue(items, translations),
    onSelect: onSelect,
    ignoreRefs: [buttonRef],
    menuPlacement: menuPlacement
  }));
};
export default Select;